import axios from 'axios';
import React, { useEffect } from 'react';
import { CircularProgress } from '@mui/material';


function OBReportDetails({ month, year, comm_id, heading }) {
  const [data, setData] = React.useState([]);
  const [message, setMessage] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_URL}/api/ob/report`, {
        month: parseInt(month, 10),
        year: parseInt(year, 10),
        comm_id: parseInt(comm_id, 10),
      })
      .then(res => {
        if (!isMounted) return;
        setData(res.data.data || []);
        setMessage(res.data.message || '');
      })
      .catch(err => {
        console.error(err);
        if (isMounted) setMessage('Failed to fetch data');
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

      return () => {
        isMounted = false;
      };
  }, [month, year, comm_id]);

  if (data.length === 0 && !loading) {
    return (
      <div align="center" style={{ margin: "20px", color: "red" }}>
       <p className='response'>{message || "No data found"}</p> 
      </div>
    );
  }

    if (loading) {
        return (
            <div align="center" style={{ margin: "20px" }}>
                <CircularProgress />
            </div>
        );
    }

  return (
    <div>
      <table align="center" width={"60%"}>
        <thead>
          <tr className="tableheader">
            <th colSpan={7}>OB Updated Details </th>
          </tr>
          <tr className="tableheader">
            <td>Sl.No</td>
            <td>FPS</td>
            <td>Scheme</td>
            <td>User </td>
            <td>Old OB</td>
            <td>New OB</td>
            <td>Trans Date</td>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.fps_id}</td>
              <td>{item.scheme_name_en}</td>
              <td>{item.user_id||'NA'}</td>
              <td>{item.old_ob||0}</td>
              <td>{item.new_ob}</td>
              <td>{item.trans_date}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />      <br />      <br />


    </div>
  );
}

export default OBReportDetails;